import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getContent } from '../../util/responseUtil';

import API_TICKET_LIST from '../../api/apiTicketList';
import API_SOLUTION from '../../api/apiSolution';
import { CheckPermissionApi } from '../../util/permission';
import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    TICKET_LIST_SOLUTION_VIEW
} from '../../constants/menuPermissionConstant';

class ShowCountTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: []
        }
    }

    getDataTicketInitiate = () => {
        if (CheckPermissionApi(TICKET_LIST_ALL_VIEW_ASSIGNEE, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiate(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_ALL_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateLead(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_NEW_CSO_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateUnassigned(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_NEW_MANAGER_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateAssignedUnassigned(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_MEMBER_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateMember(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_SOLUTION_VIEW, this.props.userDetail.permissions)) {
            return API_SOLUTION.getDataTicketInitiateSolution(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            limit: getContent(res).valid_limit
                        })
                    }
                })
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getDataTicketInitiate();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <p className="ticket-page mr-5">
                Show Ticket
                <select id="ddlticketlimit" value={this.props.limit} className="outline-none p-1 ml-1" onChange={this.props.handleChangeLimit}>
                    {
                        this.state.limit.map((limit, idx) =>
                            <option key={idx} value={limit}>{limit}</option>
                        )
                    }
                </select>
            </p>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(ShowCountTicket);